/* NEWSLETTER */
$('body').on('click', '#mc-embedded-subscribe', function() {
  if ($('#agree-newsletter').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

$('body').on('click', '#mc-embedded-subscribe-footer', function() {
  if ($('#agree-newsletter-footer').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

$('body').on('click', '#newsletter-button', function() {
  if ($('#agree-newsletter').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

$('body').on('click', '#newsletter-footer-button', function() {
  if ($('#agree-newsletter-footer').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

/* REGISTER */
$('body').on('click', '#create-customer .btn', function() {
  if ($('#agree-newsletter-register').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

/* BLOG */
// S'ha comentat un codi a l'arxiu theme.js a la linia 5409 perquè pugui funcionar el següent codi custom.
$(document).ready(function() {
  $('.menu').hide();
  $('.link-dropdown__link').click(function(){
    $(this).next('.menu').slideDown(1000).siblings('.menu').slideUp(1000);
  });
});

/* PRODUCT - Sticky mobile ATC (mirror only, triggers main button click) */
(function () {
  var MOBILE_MAX = 767;
  var observer = null;

  function getMainButton() {
    return document.querySelector('[data-section-type="main-product"] .buy-buttons-row button[type="submit"][data-add-to-cart-text]');
  }

  function syncStickyButton() {
    var stickyBtn = document.querySelector('[data-sticky-atc-button]');
    var mainBtn = getMainButton();
    if (!stickyBtn || !mainBtn) return;

    stickyBtn.innerHTML = mainBtn.innerHTML;
    stickyBtn.disabled = mainBtn.disabled;
  }

  function watchMainButton() {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var mainBtn = getMainButton();
    if (!stickyBar || !mainBtn) return;

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(function (entries) {
      var visible = entries[0] && entries[0].isIntersecting;
      stickyBar.classList.toggle('is-visible', !visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0 });

    observer.observe(mainBtn);
  }

  function refresh() {
    if (!document.querySelector('[data-sticky-atc]') || !document.body.classList.contains('template-product') || window.innerWidth > MOBILE_MAX) {
      var bar = document.querySelector('[data-sticky-atc]');
      if (bar) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
      return;
    }
    syncStickyButton();
    watchMainButton();
  }

  document.addEventListener('click', function (e) {
    var stickyBtn = e.target.closest('[data-sticky-atc-button]');
    if (!stickyBtn) return;

    e.preventDefault();
    var mainBtn = getMainButton();
    if (mainBtn && !mainBtn.disabled) {
      mainBtn.click();
    }
  });

  function init() {
    refresh();

    var buyRow = document.querySelector('[data-section-type="main-product"] .buy-buttons-row');
    if (buyRow && !buyRow.dataset.stickyAtcWatch) {
      buyRow.dataset.stickyAtcWatch = 'true';
      new MutationObserver(refresh).observe(buyRow, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }

    if (window.jQuery) {
      jQuery(window).on('cc-variant-updated.stickyAtc', refresh);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', refresh);
})();
